module.exports = __webpack_public_path__ + "img/undraw_Searching_re_3ra9.432415f1.png";